import React from "react";
import { useState, useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
// import DefaultLandingPage from "../features/components/landing-page-group";
// import Crani from "../components/layouts/HomePage";
// import EntVideoPage from "../components/layouts/EntVideoPage";
// import EntDemoPage from "../components/layouts/EntDemoPage";
import Custom404 from "../features/components/custom-404";
// import StartProjectGroupPage from "../features/components/start-project-group";
// import SpineStatic1 from "../features/spine/spine";
// import Sealonix from "../features/spine/spine-static";
// import GutLab from "../features/gutlab/gutlab";
// import Liger from "../features/liger/liger";
// import ContactThemeGenerate from "../features/components/color_theme";
// import SpineStaticLegal from "../features/utahlegal/utahlegal";
// import Login from "../userAuth/Login";
// import OtpVerify from "../userAuth/otp/OtpVerify";
import Loader from "../components/Loader/Loader";
import Layout from "../userAuth/mainLayout";
import PrivateRoute from "../userAuth/protectedRoute";

// import Subscription from "../userAuth/Subscription/subcriptionPage.tsx";

import ShortURLAnimationViewnew from "../features/animationView/animationViewnew.tsx";
const LOCAL_SHORT_URL = import.meta.env.VITE_LOCAL_SHORT_URL;
// import SignUp from "../features/components/sign-up";
// import ContactUs from "../features/contact-us/contact-us";
// import AboutUs from "../features/components/about_us.tsx";
// import PreloginHome from "../PreloginComponent/Layout/PreloginHome.tsx";

import Cookies from "js-cookie";
// import { Navigate } from "react-router-dom";
import useGoogleAnalytics from "../hooks/useGoogleAnalaytics.ts";
import { privateRoutes, publicRoutes } from "../utils/routes.tsx";
import PlayLoop from "../users/animationloop/loopvideo.tsx";

function GoogleAnalyticsTracker() {
  useGoogleAnalytics()
  return null;
}


const AppRoutes: React.FC = () => {
  const [adminLoader, setAdminLoading] = useState(true);
  const domain = window.location.hostname;
  useEffect(() => {
    const timer = setTimeout(() => {
      setAdminLoading(false);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  if (adminLoader) {
    return <Loader />;
  }

  const PublicRoute = ({ children }: { children: JSX.Element }) => {
    const token: any = Cookies.get("userToken");
    return token ? <Navigate to="/home" replace /> : children;
  };

  console.log("check route", domain !== LOCAL_SHORT_URL)

  return (
    <BrowserRouter>
      <GoogleAnalyticsTracker />
      <Routes>

        {/* Private Routes */}

        <>

          {privateRoutes.map(route => (
            <Route key={route.name}
              path={route.path}
              element={
                <PrivateRoute>
                  <Layout>
                    <route.component />
                  </Layout>
                </PrivateRoute>
              }
            />
          ))}

        </>

        {/* Public Routes */}

        <>

          {publicRoutes.map(routes => (
            <Route key={routes.path} path={routes.path} element={<PublicRoute><routes.component /></PublicRoute>} />
          ))}

        </>

        {/* Undefined Routes */}
        <>
          <Route path="/" element={<Custom404 />} />
          <Route path="/:shortCode" element={<ShortURLAnimationViewnew />} />
          <Route path="/loopvideo" element={<PlayLoop />} />
        </>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
